import {AnchorExternal} from '@raison/ui-kit';
import React, {Fragment} from 'react';
import {Link} from 'react-router';
import {env} from '~/environment';
import {TariffAttributes, TariffDescriptionProps, TariffFlag, TariffName} from './types';

const {WEB_URL} = env;

export function getPagesContent() {
    const FeelFreeToContactUs = (
        <span>
            Feel free to{' '}
            <Link className='text-primary-30' to='/support/form'>
                contact us
            </Link>{' '}
            if you have any questions.
        </span>
    );

    const ExclusiveFeaturesAvailable = (
        <Fragment>
            Exclusive features are available to you. <br /> Invest on better terms today!&nbsp;
            {FeelFreeToContactUs}
        </Fragment>
    );

    const LaunchDescription = (
        <Fragment>
            <p className='fv-text-l-regular mb-2'>
                Whether you’re a newbie investor or simply exploring your options, this plan is a great starting point
                with all our essential features included.
            </p>
            <p className='fv-text-l-regular'>
                No monthly payment is required. All applied fees can be viewed on our{' '}
                <AnchorExternal className='text-primary-30' href={`${WEB_URL}/pricing-plans`}>
                    website
                </AnchorExternal>{' '}
                or directly in the app.
            </p>
        </Fragment>
    );

    const ExclusiveTariffRequestAccepted = (
        <Fragment>
            <p className='fv-text-l-regular'>Our managers will be in touch soon to explain all the plan details.</p>
            {FeelFreeToContactUs}
        </Fragment>
    );

    const LaunchRequestAccepted = (
        <Fragment>
            <p className='fv-text-l-regular'>
                You&apos;ll be notified when your account is switched to the Launch plan.
            </p>
            {FeelFreeToContactUs}
        </Fragment>
    );

    const GrowthRequestAccepted = ExclusiveTariffRequestAccepted;
    const WealthRequestAccepted = ExclusiveTariffRequestAccepted;

    const WealthFeatures = [
        'Asset management services',
        'Investment consulting',
        'Structured products',
        'Exclusive top-tier VC deals',
        'Personal manager',
        'Early access to new VC listings',
        'Lower commissions',
        'Extended deposit limits',
        'Better exchange rate',
    ];

    const GrowthFeatures = [
        'Early access to new VC listings',
        'Lower commissions',
        'Extended deposit limits',
        'Better exchange rate',
    ];

    const descriptions: {
        [K in TariffName]: {
            active: TariffDescriptionProps;
            inactive: TariffDescriptionProps;
        };
    } = {
        Launch: {
            active: {
                textContent: LaunchDescription,
                featureList: null,
            },
            get inactive() {
                return this.active;
            },
        },
        Growth: {
            active: {
                textContent: ExclusiveFeaturesAvailable,
                featureList: GrowthFeatures,
            },
            inactive: {
                textContent: null,
                featureList: GrowthFeatures,
            },
        },
        Wealth: {
            active: {
                textContent: ExclusiveFeaturesAvailable,
                featureList: WealthFeatures,
            },
            inactive: {
                textContent: null,
                featureList: WealthFeatures,
            },
        },
    };

    const attributes: {[K in TariffName]: TariffAttributes} = {
        Launch: {
            title: TariffName.Launch,
            subtitle: 'Basic free plan',
            shortDescription: 'A basic set of investment features for each newly registered user',
            flags: [],
        },
        Growth: {
            title: TariffName.Growth,
            subtitle: 'Free from $10,000 portfolio',
            shortDescription: 'Reach a new level of investment with special offers and lower fees',
            flags: [TariffFlag.Exclusive, TariffFlag.ComingSoon],
        },
        Wealth: {
            title: TariffName.Wealth,
            subtitle: 'Customized personally',
            shortDescription: 'Get the most from your wealth through exclusive conditions',
            flags: [TariffFlag.Exclusive],
        },
    };

    const otherTexts = {
        Request: 'Request',
        BackToMyAccounts: 'Back to my accounts',
        ComingSoon: 'Coming soon',
    };

    const dialogs = {
        Launch: {
            requestAccepted: LaunchRequestAccepted,
        },
        Growth: {
            requestAccepted: GrowthRequestAccepted,
        },
        Wealth: {
            requestAccepted: WealthRequestAccepted,
        },
    };

    return {
        descriptions,
        attributes,
        texts: otherTexts,
        dialogs,
    };
}
